import { render } from "./updateOwnerForm.vue?vue&type=template&id=503f2119"
import script from "./updateOwnerForm.vue?vue&type=script&lang=js"
export * from "./updateOwnerForm.vue?vue&type=script&lang=js"

import "./updateOwnerForm.vue?vue&type=style&index=0&id=503f2119&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__